import React from 'react';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from './ui/accordion';

const faqs = [
  {
    question: 'What ZIP codes do you cover?',
    answer: 'We serve most of Pennsylvania and New Jersey, including Montgomery County, Bucks County, Philadelphia, Delaware County in PA, and Gloucester County, North Burlington County, and Camden County in NJ. Visit our booking page to check if we service your area.',
  },
  {
    question: 'How much does a repair cost?',
    answer: 'Our service call fee varies by location and appliance: PA $89-$129 and NJ $99-$149, depending on the brand and model. After the diagnostic, our technicians will provide you with a repair quote based on the complexity of the job.',
  },
  {
    question: 'Do you offer same-day or next-day service?',
    answer: 'Yes! We understand that when an appliance breaks down, you need it fixed ASAP. Our experts are available for same-day or next-day appointments to ensure your appliance is fixed quickly.',
  },
  {
    question: 'Do you offer a warranty on repairs?',
    answer: 'Yes, we provide a warranty on all our repairs. Our technicians use quality parts and stand behind their work. Specific warranty terms will be discussed with you before the repair.',
  },
  {
    question: 'What payment methods do you accept?',
    answer: 'We accept all major credit cards for your convenience.',
  },
  {
    question: 'Are your technicians qualified?',
    answer: 'Yes. All our technicians are experienced professionals who undergo thorough background checks. Your safety and satisfaction are our top priorities.',
  },
  {
    question: 'What appliance brands do you service?',
    answer: 'We service most major brands including Whirlpool, Samsung, Maytag, Kenmore, Amana, Admiral, LG, GE, Hotpoint, Roper, IKEA, and many more.',
  },
  {
    question: 'What are your operating hours?',
    answer: 'Our call center is available 7AM to 7PM, 7 days a week. You can also book online 24/7 through our website.',
  },
];

const FAQSection = () => {
  return (
    <section data-testid="faq-section" className="py-20 md:py-32 bg-white">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-12">
          <span className="inline-block px-4 py-2 bg-primary/10 text-primary rounded-full text-sm font-semibold mb-4">
            FAQ
          </span>
          <h2 className="font-heading text-3xl sm:text-4xl lg:text-5xl font-bold text-foreground mb-6">
            Frequently Asked Questions
          </h2>
          <p className="text-lg text-muted-foreground">
            Find answers to common questions about our appliance repair services.
          </p>
        </div>

        {/* FAQ Accordion */}
        <Accordion type="single" collapsible className="space-y-4">
          {faqs.map((faq, index) => (
            <AccordionItem
              key={index}
              value={`item-${index}`}
              data-testid={`faq-item-${index}`}
              className="bg-secondary/50 rounded-xl border border-border px-6"
            >
              <AccordionTrigger 
                data-testid={`faq-trigger-${index}`}
                className="font-heading font-semibold text-left text-foreground hover:text-primary py-5"
              >
                {faq.question}
              </AccordionTrigger>
              <AccordionContent 
                data-testid={`faq-content-${index}`}
                className="text-muted-foreground pb-5 leading-relaxed"
              >
                {faq.answer}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
};

export default FAQSection;
